import errorImage from '../../../shared/assets/images/404.png';
import { Button } from '../../../shared/ui/button';

const ErrorPage = () => {
  const goBack = () => {};

  return (
    <div className="w-full h-screen flex justify-center items-center">
      <h1 className="absolute text-center text-[17px] top-[94px]">
        Произошла ошибка, пожалуйста обратитесь к вашему <br /> менеджеру или
        попробуйте снова пройти все этапы регистрации
      </h1>
      <Button onClick={goBack} className="absolute top-[30px] w-[300px]">
        Вернуться к заполнению
      </Button>
      <img src={errorImage} alt="error" />
    </div>
  );
};

export default ErrorPage;
